<template>
  <v-container class="mt-10">
    <!-- 見出し -->
    <SubTitle :title-name="sectionName" />

    <!-- DLC本体 -->
    <DlcSection :dlc="dlcData" />

    <!-- 購入ボタン -->
    <BuyButton :src="dlcData.bnr" :href="dlcData.link" />
  </v-container>
</template>

<script setup>
  import SubTitle from "./SubTitle.vue";
  import DlcSection from "./DlcSection.vue";
  import BuyButton from "./BuyButton.vue";

  const dlcData = {
    title: "DLC第一弾\n「毒花の園～茶道部のひめごと～」",
    price: "1000円（税込）",
    release: "2026年6月25日",
    mainImage: "http://d-mebius.com/apathyreikaiki/img/eshopdlc1.jpg",

    bnr: "http://d-mebius.com/apathyreikaiki/img/bnrsado.png",
    link: "https://store-jp.nintendo.com/item/software/D70050000075490",
  };

  const sectionName = "ダウンロードコンテンツ";
</script>
